import { useQuery } from '@tanstack/react-query';
import availabilityApi from '@/features/dashboard/availability/api/availabilityApi.ts';
import { availabilityApiQueryKeys } from '@/features/dashboard/availability/api/availabilityApi.queryKeys.ts';
import {
  AvailabilityInfoDto,
  CatalogRefDto,
} from '@/features/dashboard/availability/types/AvailabilityDto.ts';

/**
 * Obłożenie wskazanych pozycji katalogu, po identyfikatorze pozycji.
 *
 * `staleTime` jest krótki, bo to liczba, którą ktoś inny zmienia w tle: między
 * otwarciem okna a wprowadzeniem paczki miejsce potrafi zniknąć. Odpowiedź jest
 * **wskazówką, nie gwarancją** — o wejściu paczki rozstrzyga backend przy jej
 * wprowadzaniu, bo dopiero wtedy miejsce zostaje zajęte.
 */
const useCatalogAvailability = (
  tourId: string | undefined,
  refs: CatalogRefDto[],
) => {
  const query = useQuery({
    queryKey: availabilityApiQueryKeys.forRefs(
      tourId ?? '',
      refs.map((ref) => ref.id),
    ),
    queryFn: () => availabilityApi.getAvailability({ tourId: tourId!, refs }),
    enabled: !!tourId && refs.length > 0,
    staleTime: 1000 * 15,
  });

  const byId = new Map<string, AvailabilityInfoDto>(
    (query.data ?? []).map((entry) => [
      entry.availability.entityId,
      entry.availability,
    ]),
  );

  return { byId, isLoading: query.isLoading };
};

export default useCatalogAvailability;
